import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FieldArray } from 'redux-form'
import { Table, Data } from 'components/layout/Table'
import { Button } from 'components/misc'
import { Checkbox, InputDate } from 'components/fields'
import { ajPreparationTrainings as ajPreparationTrainingsLayout } from 'constants/layout'

export default class AwardPreparationTrainingsTable extends Component {
  static propTypes = {
    list: PropTypes.array,
    loading: PropTypes.bool,
    onRemove: PropTypes.func,
    userDefined: PropTypes.bool
  }

  static defaultProps = {
    list: [],
    userDefined: false
  }

  renderTableRows = ({ fields }) => {
    const { list, onRemove, userDefined } = this.props
    const styles = {
      float: 'right'
    }

    return (
      <Data>
        {fields
          .map((training, index) => {
            return (
              <tr key={index}>
                <td>
                  {list[index].name}
                  {onRemove && (
                    <Button
                      style={styles}
                      type="button"
                      onClick={() => onRemove(list[index].id)}
                      secondary
                      intlKey="button.remove"
                    >
                      Remove
                    </Button>
                  )}
                </td>
                <td>
                  <InputDate
                    name={`${training}.date`}
                    label="Date"
                    intlKey="label.date"
                    labelless
                    compact
                    maxToday
                  />
                </td>
                <td className="text--center">
                  <Checkbox
                    name={`${training}.isCompleted`}
                    label="Is completed"
                    labelless
                    inTable
                  />
                </td>
              </tr>
            )
          })
          .filter((item, index) => list[index].isAddedByUser === userDefined)}
      </Data>
    )
  }

  render() {
    const { loading, list } = this.props

    if (list.length === 0) {
      return null
    }

    return (
        <div style={{ width: '98%', margin: 'auto' }}>
      <Table
        loading={loading}
        length={list.length}
        ths={ajPreparationTrainingsLayout.tableHeaders}
      >
        <FieldArray name="trainings" component={this.renderTableRows} />
      </Table>
        </div>
    )
  }
}
